export const IBAN_BLOCKS = {
  BE: [4, 4, 4, 4],
  BG: [4, 4, 4, 4, 4, 2],
  DK: [4, 4, 4, 4, 2],
  DE: [4, 4, 4, 4, 4, 2],
  EE: [4, 4, 4, 4, 4],
  FI: [4, 4, 4, 4, 2],
  FR: [4, 4, 4, 4, 4, 4, 3],
  GR: [4, 4, 4, 4, 4, 4, 4],
  IE: [4, 4, 4, 4, 4, 2],
  IS: [4, 4, 4, 4, 4, 4, 2],
  IT: [4, 4, 4, 4, 4, 4, 3],
  LI: [4, 4, 4, 4, 4, 1],
  LT: [4, 4, 4, 4, 4],
  LU: [4, 4, 4, 4, 4],
  MT: [4, 4, 4, 4, 4, 4, 4, 4],
  MC: [4, 4, 4, 4, 4, 4, 3],
  NL: [4, 4, 4, 4, 2],
  NO: [4, 4, 4, 4],
  AT: [4, 4, 4, 4, 4],
  PL: [4, 4, 4, 4, 4, 4, 4],
  PT: [4, 4, 4, 4, 4, 4, 1],
  RO: [4, 4, 4, 4, 4, 4],
  SE: [4, 4, 4, 4, 4, 4],
  CH: [4, 4, 4, 4, 4, 1],
  SK: [4, 4, 4, 4, 4, 4],
  SI: [4, 4, 4, 4, 3],
  ES: [4, 4, 4, 4, 4, 4],
  CZ: [4, 4, 4, 4, 4, 4],
  HU: [4, 4, 4, 4, 4, 4, 4],
  GB: [4, 4, 4, 4, 4, 2],
  CY: [4, 4, 4, 4, 4, 4, 4],
};